import React, { useEffect, useState } from "react";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { ADS_TYPE } from "../../../constant/constant";

const foriegnKey = {
  ad_type: ADS_TYPE,
};

// Icon mapping for each ad type key
const adTypeIconMap = {
  META: "fab fa-meta",
  GOOGLE: "fab fa-google",
  LINKEDIN: "fab fa-linkedin",
  YOUTUBE: "fab fa-youtube",
  SNAPCHAT: 'fab fa-snapchat'
};

export const TextWithIconCell = (props) => {
  const field = props?.field || "";
  const getNestedValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  };
  
  const value = field.includes('.') 
    ? getNestedValue(props.dataItem, field) 
    : props.dataItem?.[field];
  
  const [display, setDisplay] = useState({ icon: "", label: "" });

  useEffect(() => {
    loadData();
  }, [value]);

  const loadData = () => {
    let matchedKey = Object.keys(foriegnKey.ad_type).find(
      (key) => foriegnKey.ad_type[key] === value
    );

    const icon = adTypeIconMap[matchedKey] || "fas fa-ad"; // fallback icon
    const label = value;

    setDisplay({ icon, label });
  };

  return (
    <td
      colSpan={props?.colSpan}
      role={"gridcell"}
      aria-colindex={props?.ariaColumnIndex}
      aria-selected={props?.isSelected}
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props?.columnIndex }}
      {...useTableKeyboardNavigation(props?.id)}
      style={{ display: "flex", alignItems: "center", gap: "8px", ...props.style }}
    >
      {display?.icon && <i className={display.icon} style={{ fontSize: "18px" }}></i>}
      <span>{display.label}</span>
    </td>
  );
};